import axios from '../../../../utills/axiosConfig';

export const fetchStoneClarities = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/stone-clarities', { params });
  return res.data;
};

export const addStoneClarity = async (stoneClarity) => {
  try {
    const res = await axios.post('/stone-clarities', stoneClarity);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateStoneClarity = async (id, stoneClarity) => {
  console.log('API call - Updating stone clarity:', id, stoneClarity);
  const res = await axios.put(`/stone-clarities/${id}`, stoneClarity);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteStoneClarity = async (id) => {
  const res = await axios.delete(`/stone-clarities/${id}`);
  return res.data;
};

export const importStoneClarityCSV = async (formData) => {
  const { data } = await axios.post('/stone-clarities/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 